import { useAppDispatch, useAppSelector } from 'appState/store'
import { resetProcessedFilters } from 'features/autocheck/autoCheckSlice'
import { settingsServiceApiPaths, setUserPreference } from 'features/settings/settingsApi'
import { UserPreferencesKeysEnum } from 'features/settings/settingsTypes'
import { useEffect, useState } from 'react'
import { Button } from '@outbound-ai/ursa'
import styled, { css } from 'styled-components'

interface ProcessedActiveFiltersProps {
  gridApi: any
}

export const ProcessedActiveFilters = ({ gridApi }: ProcessedActiveFiltersProps) => {
  const { processedFilters } = useAppSelector((state) => state.batch)
  const [filterLength, setFilterLength] = useState(0)

  const dispatch = useAppDispatch()

  useEffect(() => {
    setFilterLength(Object.keys(processedFilters || {})?.length)
  }, [processedFilters])

  if (!filterLength) return <></>

  const handleClearAll = async () => {
    if (filterLength) {
      dispatch(resetProcessedFilters())
      await setUserPreference(settingsServiceApiPaths.tenantUserPreferencesPut(), {
        key: UserPreferencesKeysEnum.batchProcessedFilters,
        value: JSON.stringify({}),
      })
      if (gridApi?.api) {
        gridApi.api.setFilterModel(null)
      }
    }
  }

  // variables
  const filtersCount = filterLength ? filterLength : 0
  const filtersTextPlural = filtersCount > 1 ? 's' : ''

  return (
    <Div data-testid="processedActiveFiltersContainer" hasFilters={!!filterLength}>
      <div className="display user-select-none">
        <span data-testid="activeFiltersDisplay">
          <span>
            {filtersCount} Filter{filtersTextPlural} Applied
          </span>
        </span>
      </div>

      <Button
        data-testid="processedActiveFiltersClearAll"
        variant="primary"
        radius="rounded"
        size="small"
        onClick={handleClearAll}
      >
        Clear All
      </Button>
    </Div>
  )
}

const Div = styled.div<{ hasFilters: boolean }>`
  display: ${({ hasFilters }) => (hasFilters ? 'flex' : 'none')};
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: ${({ theme }) => theme.spacing.s};

  .display,
  .clear {
    display: flex;
    align-items: center;
    padding: 0.25rem 0.375rem;
    gap: 0.25rem;
    line-height: 1.5rem;
    cursor: default;

    ${({ hasFilters }) =>
      hasFilters &&
      css`
        &:hover {
          cursor: pointer;
        }
      `}
  }

  .display {
    height: 32px;
    margin-right: 4px;
    background: ${({ theme }) => theme.colors.grey.lightest};
    color: ${({ theme }) => theme.colors.grey.dark};
    font-size: 0.775rem;
    font-weight: 600;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    line-height: 1.14;
    white-space: nowrap;
    margin-left: 0.5rem;
  }
`
